import { render, staticRenderFns } from "./AsthmaParameterNode.vue?vue&type=template&id=cc584322&"
import script from "./AsthmaParameterNode.vue?vue&type=script&lang=js&"
export * from "./AsthmaParameterNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports